import { render, staticRenderFns } from "./SurveyApproverContainer.vue?vue&type=template&id=998b1a44"
import script from "./SurveyApproverContainer.ts?vue&type=script&lang=ts&external"
export * from "./SurveyApproverContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports